import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap'
import EventSelect from './EventSelect'
import UserSelect from './UserSelect'

export default function StatisticsForm({ parameters, setRoute }) {
  console.log('StatisticsForm rendered: ', parameters)

  const [inputs, setInputs] = useState(parameters)
  useEffect(() => {
    setInputs(parameters)
  }, [parameters])

  useEffect(() => {
    function handleUserClickedEvent(msg, data) {
      console.log(`EVENT RECEIVED (StatisticsForm): ${msg}`, data)
      setRoute({ ...inputs, 'userId': data })
    }
    function handleEventClickedEvent(msg, data) {
      console.log(`EVENT RECEIVED (StatisticsForm): ${msg}`, data)
      setRoute({ ...inputs, 'eventId': data })
    }
    const userToken = PubSub.subscribe('STATISTICS USER CLICKED', handleUserClickedEvent)
    const eventToken = PubSub.subscribe('STATISTICS EVENT CLICKED', handleEventClickedEvent)
    return function cleanup() {
      PubSub.unsubscribe(userToken)
      PubSub.unsubscribe(eventToken)
    }
  })

  console.log('StatisticsForm inputs: ', inputs)

  function resetButtonClicked(e) {
    e.preventDefault()
    setInputs({ eventId: '', userId: '', fromDate: '', toDate: '' })
  }

  function goButtonClicked(e) {
    e.preventDefault()
    setRoute(inputs)
  }

  function handleChange(e) {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }

  return (
    <div style={{ display: 'inline-block', padding: '5px'}}>
      <Form>
        <Row>
          <Col>
            <FormGroup>
              <Label for="event" style={{ float: 'left'}}>Event</Label>
              <EventSelect value={inputs.eventId} handleChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="user" style={{ float: 'left'}}>User</Label>
              <UserSelect value={inputs.userId} handleChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="from-date" style={{ float: 'left'}}>From</Label>
              <Input type="date" name="fromDate" id="from-date" value={inputs.fromDate} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="to-date" style={{ float: 'left'}}>To</Label>
              <Input type="date" name="toDate" id="to-date" value={inputs.toDate} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col style={{ marginTop: '27px'}}>
            <Button color="primary" onClick={(e) => goButtonClicked(e)}>Go</Button>
            <Button color="secondary" className="statistics-form-reset-button" onClick={(e) => resetButtonClicked(e)}>Reset</Button>
          </Col>
        </Row>
      </Form>
    </div>
  )
}
